export const SHOWS_ROUTE = '/shows';
export const MAIN_ROUTE = '/app';
